import DataTable from "react-data-table-component";

const PlayersByTeamId = (props) => {
    const { playerByTeamData, loading } = props;

    const columns = [
        {
            name: 'S.No',
            selector: (row, index) => index + 1,
            sortable: false,
            width: '60px',
        },
        {
            name: "Name",
            selector: row => (
                <div>
                    <p>{row.playerName}</p>
                </div>
            ),
            sortable: true,
            minWidth: '200px'
        },
        {
            name: 'Role',
            selector: row => row.playerRole,
            sortable: false,
            minWidth: '100px'

        },
        {
            name: 'Individual Player',
            cell: row => (
                row.individualPlayerId ? (
                    <div>YES</div>
                ) : (
                    <div>No</div>
                )
            ),
            sortable: false,
            minWidth: '100px'
        }
    ];

    return (
        <>
            <DataTable
                columns={columns}
                data={playerByTeamData || []}
                progressPending={loading}
                progressComponent={<p>Loading...</p>}
                pagination
                highlightOnHover
                paginationPerPage={13}
            />
        </>
    )
}

export default PlayersByTeamId;